import { render, staticRenderFns } from "./editEmpresa.vue?vue&type=template&id=a0b2ff02&scoped=true&"
import script from "./editEmpresa.vue?vue&type=script&lang=js&"
export * from "./editEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b2ff02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0b2ff02')) {
      api.createRecord('a0b2ff02', component.options)
    } else {
      api.reload('a0b2ff02', component.options)
    }
    module.hot.accept("./editEmpresa.vue?vue&type=template&id=a0b2ff02&scoped=true&", function () {
      api.rerender('a0b2ff02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/perfilEmpresa/editEmpresa.vue"
export default component.exports